window.INFANT_SIZE_GUIDE_DATA={
  "version": "1.0-DRAFT",
  "_gate": "Diaper kg per brand+LINE from deep-research (Gemini, RO market: pampers.ro/emag/huggies.ro/agnotis.com): Pampers Nr7=15+ (corrected from 17+); Pants/Night lines differ from Tape (e.g. PC Pants Nr4 9-15, Nr6 13-19). Footwear data added for PHASE 2 (Drool Nr→EU + generic EU), popup NOT wired yet. Clothing chart confirmed by research. USER: final glance vs packaging recommended before go-live.",
  "type_map": {
    "Scutece": "diaper",
    "Salopete": "clothing",
    "body-uri-și-maiouri-1": "clothing",
    "Pijamale": "clothing",
    "Rochii": "clothing",
    "Tricouri": "clothing",
    "Hanorace": "clothing",
    "Bluze": "clothing",
    "Pantaloni": "clothing",
    "Geci": "clothing",
    "Costume": "clothing",
    "Seturi": "clothing",
    "Încălțăminte": "footwear"
  },
  "size_option_names": [
    "marime",
    "marimea",
    "marimi"
  ],
  "clothing": {
    "primary": "height",
    "unit": "cm",
    "texts": {
      "title": "Ghid de mărimi",
      "subtitle": "Haine · bebeluși și copii",
      "info": "Mărimile sunt orientative. Alege în primul rând după înălțimea copilului.",
      "tip": "Dacă cel mic este între două mărimi, alege mărimea mai mare — pentru confort și libertate de mișcare."
    },
    "bands": [
      {
        "label": "0-1 luni",
        "size": "50-56",
        "height": [50, 56],
        "weight": [3, 4.5],
        "age_months": [0, 1],
        "group": "Bebeluși"
      },
      {
        "label": "1-3 luni",
        "size": "56-62",
        "height": [56, 62],
        "weight": [4.5, 6],
        "age_months": [1, 3],
        "group": "Bebeluși"
      },
      {
        "label": "3-6 luni",
        "size": "62-68",
        "height": [62, 68],
        "weight": [6, 8],
        "age_months": [3, 6],
        "group": "Bebeluși"
      },
      {
        "label": "6-9 luni",
        "size": "68-74",
        "height": [68, 74],
        "weight": [8, 9.5],
        "age_months": [6, 9],
        "group": "Bebeluși"
      },
      {
        "label": "9-12 luni",
        "size": "74-80",
        "height": [74, 80],
        "weight": [9.5, 11],
        "age_months": [9, 12],
        "group": "Bebeluși"
      },
      {
        "label": "12-18 luni",
        "size": "80-86",
        "height": [80, 86],
        "weight": [11, 12.5],
        "age_months": [12, 18],
        "group": "Bebeluși"
      },
      {
        "label": "18-24 luni",
        "size": "86-92",
        "height": [86, 92],
        "weight": [12.5, 14],
        "age_months": [18, 24],
        "group": "Bebeluși"
      },
      {
        "label": "2-3 ani",
        "size": "92-98",
        "height": [92, 98],
        "weight": [14, 16],
        "age_months": [24, 36],
        "group": "Copii"
      },
      {
        "label": "3-4 ani",
        "size": "98-104",
        "height": [98, 104],
        "weight": [16, 18],
        "age_months": [36, 48],
        "group": "Copii"
      },
      {
        "label": "4-5 ani",
        "size": "104-110",
        "height": [104, 110],
        "weight": [18, 20],
        "age_months": [48, 60],
        "group": "Copii"
      },
      {
        "label": "5-6 ani",
        "size": "110-116",
        "height": [110, 116],
        "weight": [20, 22],
        "age_months": [60, 72],
        "group": "Copii"
      },
      {
        "label": "6-7 ani",
        "size": "116-122",
        "height": [116, 122],
        "weight": [22, 25],
        "age_months": [72, 84],
        "group": "Copii"
      },
      {
        "label": "7-8 ani",
        "size": "122-128",
        "height": [122, 128],
        "weight": [25, 28],
        "age_months": [84, 96],
        "group": "Copii"
      },
      {
        "label": "8-9 ani",
        "size": "128-134",
        "height": [128, 134],
        "weight": [28, 32],
        "age_months": [96, 108],
        "group": "Copii"
      },
      {
        "label": "9-10 ani",
        "size": "134-140",
        "height": [134, 140],
        "weight": [32, 36],
        "age_months": [108, 120],
        "group": "Copii"
      },
      {
        "label": "10-11 ani",
        "size": "140-146",
        "height": [140, 146],
        "weight": [36, 41],
        "age_months": [120, 132],
        "group": "Copii"
      },
      {
        "label": "11-12 ani",
        "size": "146-152",
        "height": [146, 152],
        "weight": [41, 46],
        "age_months": [132, 144],
        "group": "Copii"
      }
    ]
  },
  "diaper": {
    "primary": "weight",
    "unit": "kg",
    "texts": {
      "title": "Ghid de mărimi",
      "subtitle": "Scutece · după greutate",
      "info": "Scutecele se aleg după greutatea copilului, nu după vârstă.",
      "tip": "La limita dintre două mărimi, ia mărimea mai mare — mai puține scurgeri."
    },
    "brands": {
      "pampers": {
        "premium care pants": [
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [6, 11]
          },
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 15]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [12, 17]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [13, 19]
          }
        ],
        "active baby pants": [
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [6, 11]
          },
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 15]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [11, 17]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [13, 19]
          },
          {
            "nr": "7",
            "label": "Nr. 7",
            "weight": [15, 30],
            "display": "15+ kg"
          },
          {
            "nr": "8",
            "label": "Nr. 8",
            "weight": [17, 30],
            "display": "17+ kg"
          }
        ],
        "night pants": [
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 15]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [12, 17]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [15, 30],
            "display": "15+ kg"
          }
        ],
        "premium care": [
          {
            "nr": "1",
            "label": "Nr. 1 · Newborn",
            "weight": [2, 5]
          },
          {
            "nr": "2",
            "label": "Nr. 2 · Mini",
            "weight": [4, 8]
          },
          {
            "nr": "3",
            "label": "Nr. 3 · Midi",
            "weight": [6, 10]
          },
          {
            "nr": "4",
            "label": "Nr. 4 · Maxi",
            "weight": [9, 14]
          },
          {
            "nr": "5",
            "label": "Nr. 5 · Junior",
            "weight": [11, 16]
          },
          {
            "nr": "6",
            "label": "Nr. 6 · XL",
            "weight": [13, 18]
          },
          {
            "nr": "7",
            "label": "Nr. 7",
            "weight": [15, 30],
            "display": "15+ kg"
          }
        ],
        "active baby": [
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [6, 10]
          },
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 14]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [11, 16]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [13, 18]
          }
        ],
        "_default": [
          {
            "nr": "1",
            "label": "Nr. 1",
            "weight": [2, 5]
          },
          {
            "nr": "2",
            "label": "Nr. 2",
            "weight": [4, 8]
          },
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [6, 10]
          },
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 14]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [11, 16]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [13, 18]
          },
          {
            "nr": "7",
            "label": "Nr. 7",
            "weight": [15, 30],
            "display": "15+ kg"
          }
        ]
      },
      "huggies": {
        "little swimmers": [
          {
            "nr": "2-3",
            "label": "Nr. 2-3",
            "weight": [3, 8]
          },
          {
            "nr": "3-4",
            "label": "Nr. 3-4",
            "weight": [7, 15]
          },
          {
            "nr": "5-6",
            "label": "Nr. 5-6",
            "weight": [12, 18]
          }
        ],
        "extra care pants": [
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [6, 11]
          },
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 14]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [12, 17]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [15, 25]
          }
        ],
        "_default": [
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [6, 11]
          },
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 14]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [12, 17]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [15, 25]
          }
        ]
      },
      "agnotis": {
        "pants": [
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 15]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [13, 17]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [17, 30],
            "display": "17+ kg"
          }
        ],
        "supreme": [
          {
            "nr": "2",
            "label": "Nr. 2",
            "weight": [4, 8]
          },
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [6, 10]
          },
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 14]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [13, 17]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [17, 30],
            "display": "17+ kg"
          }
        ],
        "_default": [
          {
            "nr": "2",
            "label": "Nr. 2",
            "weight": [4, 8]
          },
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [6, 10]
          },
          {
            "nr": "4",
            "label": "Nr. 4",
            "weight": [9, 14]
          },
          {
            "nr": "5",
            "label": "Nr. 5",
            "weight": [13, 17]
          },
          {
            "nr": "6",
            "label": "Nr. 6",
            "weight": [17, 30],
            "display": "17+ kg"
          }
        ]
      },
      "babyjem": {
        "_default": [
          {
            "nr": "2",
            "label": "Nr. 2",
            "weight": [12, 14]
          },
          {
            "nr": "3",
            "label": "Nr. 3",
            "weight": [14, 18]
          }
        ]
      },
      "_default": [
        {
          "nr": "1",
          "label": "Nr. 1",
          "weight": [2, 5]
        },
        {
          "nr": "2",
          "label": "Nr. 2",
          "weight": [4, 8]
        },
        {
          "nr": "3",
          "label": "Nr. 3",
          "weight": [6, 10]
        },
        {
          "nr": "4",
          "label": "Nr. 4",
          "weight": [9, 14]
        },
        {
          "nr": "5",
          "label": "Nr. 5",
          "weight": [11, 16]
        },
        {
          "nr": "6",
          "label": "Nr. 6",
          "weight": [13, 18]
        },
        {
          "nr": "7",
          "label": "Nr. 7",
          "weight": [15, 30],
          "display": "15+ kg"
        }
      ]
    }
  },
  "footwear": {
    "primary": "foot_length",
    "unit": "cm",
    "_phase": "2 — data ready, popup not wired yet",
    "texts": {
      "title": "Ghid de mărimi",
      "subtitle": "Încălțăminte · număr EU",
      "info": "Măsoară talpa piciorului în picioare și adaugă 0,5-1 cm spațiu de creștere.",
      "tip": "Lasă ~1 cm în vârf și reverifică la 6-8 săptămâni."
    },
    "brands": {
      "drool": [
        {
          "label": "Nr. 1",
          "eu": 17,
          "foot_cm": [10.0, 11.0],
          "age": "0-6 luni"
        },
        {
          "label": "Nr. 2",
          "eu": 19,
          "foot_cm": [11.1, 12.0],
          "age": "6-12 luni"
        },
        {
          "label": "Nr. 3",
          "eu": 20,
          "foot_cm": [12.1, 13.0],
          "age": "12-18 luni"
        }
      ],
      "_generic_eu": [
        {
          "eu": 17,
          "foot_cm": [10.0, 10.5],
          "age": "0-3 luni"
        },
        {
          "eu": 18,
          "foot_cm": [10.6, 11.0],
          "age": "3-6 luni"
        },
        {
          "eu": 19,
          "foot_cm": [11.1, 11.6],
          "age": "6-9 luni"
        },
        {
          "eu": 20,
          "foot_cm": [11.7, 12.1],
          "age": "9-12 luni"
        },
        {
          "eu": 21,
          "foot_cm": [12.2, 13.1],
          "age": "12-18 luni"
        },
        {
          "eu": 22,
          "foot_cm": [13.2, 14.1],
          "age": "18-24 luni"
        },
        {
          "eu": 23,
          "foot_cm": [14.2, 14.7],
          "age": "2-2,5 ani"
        },
        {
          "eu": 24,
          "foot_cm": [14.8, 15.0],
          "age": "2,5-3 ani"
        },
        {
          "eu": 25,
          "foot_cm": [15.1, 15.7],
          "age": "3 ani+"
        },
        {
          "eu": 26,
          "foot_cm": [15.8, 16.4],
          "age": "3 ani+"
        },
        {
          "eu": 27,
          "foot_cm": [16.5, 17.0],
          "age": "4 ani+"
        },
        {
          "eu": 28,
          "foot_cm": [17.1, 17.7],
          "age": "5 ani+"
        },
        {
          "eu": 29,
          "foot_cm": [17.8, 18.4],
          "age": "5 ani+"
        },
        {
          "eu": 30,
          "foot_cm": [18.5, 19.1],
          "age": "6 ani+"
        }
      ]
    }
  }
};
// shopify_storefront/theme_inject/size-guide-match.js
// Pure size-matching logic. No DOM. Usable in browser (window.SizeGuideMatch) and Node (require).
(function (root) {
  'use strict';

  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function ageIntervalFromLabel(label) {
    var s = norm(label);
    var isAni = /\ban[i]?\b/.test(s);
    var isLuni = /\blun[i]?\b/.test(s);
    if (!isAni && !isLuni) return null;
    var mul = isAni ? 12 : 1;
    var range = s.match(/(\d+(?:[.,]\d+)?)\s*-\s*(\d+(?:[.,]\d+)?)/);
    if (range) {
      return [parseFloat(range[1].replace(',', '.')) * mul, parseFloat(range[2].replace(',', '.')) * mul];
    }
    var single = s.match(/(\d+(?:[.,]\d+)?)/);
    if (single) { var n = parseFloat(single[1].replace(',', '.')) * mul; return [n, n]; }
    return null;
  }

  function cmIntervalFromLabel(label) {
    var s = norm(label);
    if (/lun|ani|\ban\b|nr/.test(s)) return null;
    var range = s.match(/(\d{2,3})\s*[-\/]\s*(\d{2,3})/);
    if (range) return [parseInt(range[1], 10), parseInt(range[2], 10)];
    var single = s.match(/^(\d{2,3})$/);
    if (single) { var n = parseInt(single[1], 10); return [n, n]; }
    return null;
  }

  function labelToHeightInterval(label, bands) {
    var cm = cmIntervalFromLabel(label);
    if (cm) return cm;
    var age = ageIntervalFromLabel(label);
    if (!age) {
      var nl = norm(label);
      for (var i = 0; i < bands.length; i++) {
        if (norm(bands[i].label) === nl || norm(bands[i].size) === nl) return bands[i].height.slice();
      }
      return null;
    }
    var lo = null, hi = null;
    for (var j = 0; j < bands.length; j++) {
      var b = bands[j], ba = b.age_months;
      var overlaps = age[0] < ba[1] && age[1] > ba[0];
      var pointInside = age[0] === age[1] && age[0] >= ba[0] && age[0] <= ba[1];
      if (overlaps || pointInside) {
        if (lo === null || b.height[0] < lo) lo = b.height[0];
        if (hi === null || b.height[1] > hi) hi = b.height[1];
      }
    }
    return lo === null ? null : [lo, hi];
  }

  function bandIndexForHeight(height, bands) {
    // Assumes contiguous bands (real clothing chart is). If a future edit makes them
    // non-contiguous, the -1 fallback must be handled by callers (bands[-1] is undefined).
    for (var i = 0; i < bands.length; i++) {
      var h = bands[i].height, last = i === bands.length - 1;
      if (last ? (height >= h[0] && height <= h[1]) : (height >= h[0] && height < h[1])) return i;
    }
    if (height < bands[0].height[0]) return 0;
    if (height > bands[bands.length - 1].height[1]) return bands.length - 1;
    return -1;
  }

  function bandIndexForWeight(weight, bands) {
    // Mirror of bandIndexForHeight against band.weight. Half-open [lo,hi) for interior
    // bands, closed [lo,hi] for the last. Assumes contiguous weight bands; a gap returns
    // -1 (callers must handle bands[-1] === undefined).
    for (var i = 0; i < bands.length; i++) {
      var w = bands[i].weight, last = i === bands.length - 1;
      if (last ? (weight >= w[0] && weight <= w[1]) : (weight >= w[0] && weight < w[1])) return i;
    }
    if (weight < bands[0].weight[0]) return 0;
    if (weight > bands[bands.length - 1].weight[1]) return bands.length - 1;
    return -1;
  }

  function nearestInStock(fitLabel, bands, productSizes) {
    // Given the (likely OOS) recommended fit label, suggest the nearest IN-STOCK product
    // size by height interval. Prefer the nearest same-or-larger in stock; else the nearest
    // smaller in stock; else null. Returns the label string (or null) for direct display.
    var fitIv = labelToHeightInterval(fitLabel, bands);
    if (!fitIv) return null;
    var resolved = productSizes.map(function (ps) {
      return { label: ps.label, available: ps.available !== false, iv: labelToHeightInterval(ps.label, bands) };
    }).filter(function (r) { return r.iv && r.available; });
    if (!resolved.length) return null;
    var larger = resolved.filter(function (r) { return r.iv[0] >= fitIv[0]; });
    if (larger.length) {
      larger.sort(function (a, b) { return a.iv[0] - b.iv[0]; }); // smallest lo = nearest larger
      return larger[0].label;
    }
    var smaller = resolved.filter(function (r) { return r.iv[0] < fitIv[0]; });
    if (smaller.length) {
      smaller.sort(function (a, b) { return b.iv[0] - a.iv[0]; }); // largest lo = nearest smaller
      return smaller[0].label;
    }
    return null;
  }

  function pickProductSize(height, bands, productSizes) {
    var resolved = productSizes.map(function (ps) {
      return { label: ps.label, available: ps.available !== false, iv: labelToHeightInterval(ps.label, bands) };
    }).filter(function (r) { return r.iv; });
    if (!resolved.length) return null;
    resolved.sort(function (a, b) { return a.iv[0] - b.iv[0]; });
    var containing = resolved.filter(function (r) { return height >= r.iv[0] && height <= r.iv[1]; });
    if (containing.length) {
      containing.sort(function (a, b) { return b.iv[1] - a.iv[1]; });
      return { label: containing[0].label, status: 'exact' };
    }
    var larger = resolved.filter(function (r) { return r.iv[0] >= height; });
    if (larger.length) return { label: larger[0].label, status: 'larger' };
    return { label: resolved[resolved.length - 1].label, status: 'exceeds' };
  }

  function parseDiaperTitle(title, brandsConfig) {
    var s = norm(title);
    var nrMatch = s.match(/nr\.?\s*(\d+\+?)/);
    var nr = nrMatch ? nrMatch[1] : null;
    var brand = null;
    Object.keys(brandsConfig || {}).forEach(function (bk) {
      if (bk === '_default') return;
      if (s.indexOf(norm(bk)) !== -1) brand = bk;
    });
    return { brand: brand, nr: nr, raw: title };
  }

  function recommendDiaperNr(weight, table) {
    // Diaper tables OVERLAP heavily (esp. "Pants": Nr4 [9,15], Nr5 [12,17], Nr6 [13,19]).
    // Picking the largest containing size pushes most babies to the top size (loose,
    // leaky). Instead: take the SMALLEST size that fits (first whose upper bound covers
    // the weight), then size up ONE step only if the weight is past that size's midpoint
    // and a larger size exists — "size up near the top", spec §8. Keeps 9 kg -> Nr 4.
    if (weight < table[0].weight[0]) return { nr: table[0].nr, status: 'below' };
    var i = 0;
    while (i < table.length && weight > table[i].weight[1]) i++;
    if (i >= table.length) return { nr: table[table.length - 1].nr, status: 'above' };
    var s = table[i];
    var mid = (s.weight[0] + s.weight[1]) / 2;
    if (weight > mid && i + 1 < table.length) return { nr: table[i + 1].nr, status: 'exact' };
    return { nr: s.nr, status: 'exact' };
  }

  var api = {
    norm: norm, ageIntervalFromLabel: ageIntervalFromLabel, cmIntervalFromLabel: cmIntervalFromLabel,
    labelToHeightInterval: labelToHeightInterval, bandIndexForHeight: bandIndexForHeight,
    bandIndexForWeight: bandIndexForWeight, nearestInStock: nearestInStock,
    pickProductSize: pickProductSize, parseDiaperTitle: parseDiaperTitle, recommendDiaperNr: recommendDiaperNr
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.SizeGuideMatch = api;
})(typeof window !== 'undefined' ? window : globalThis);
// shopify_storefront/theme_inject/infant-size-guide.js
// DOM/UI for the size guide. Expects window.SizeGuideMatch + window.INFANT_SIZE_GUIDE_DATA.
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  var DATA = window.INFANT_SIZE_GUIDE_DATA, M = window.SizeGuideMatch;
  if (!DATA || !M) return;

  // ---- read product JSON (theme exposes it; fallback to .js fetch) ----
  function getProduct() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        return window.ShopifyAnalytics.meta.product; // has type, variants (limited)
      }
    } catch (e) {}
    return null;
  }

  // ---- detect type: override tag -> type_map -> size-option fallback -> null ----
  function detectType(product, tags, options) {
    var t = (tags || []).map(function (x) { return M.norm(x); });
    if (t.indexOf('size-guide:none') !== -1) return null;
    for (var i = 0; i < t.length; i++) {
      var mt = t[i].match(/^size-guide:(clothing|diaper|footwear)$/);
      if (mt) return mt[1];
    }
    var mapped = DATA.type_map[product && product.type];
    if (mapped) return mapped;
    // fallback: has a size option with age/cm values -> clothing
    var hasSize = (options || []).some(function (o) {
      return DATA.size_option_names.indexOf(M.norm(o.name || o)) !== -1;
    });
    if (hasSize) return 'clothing';
    return null;
  }

  // Fetch full product .js for tags/options/variants (ShopifyAnalytics.meta is thin).
  function fetchProductJson(cb) {
    var handle = location.pathname.split('/products/')[1].split(/[?#]/)[0];
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) { cb(p); }).catch(function () { cb(null); });
  }

  function init(product) {
    if (!product) return;
    var type = detectType(product, product.tags, product.options);
    if (type === 'footwear') return; // Phase 2 — no popup yet
    if (!type) return;

    // Document-level CAPTURE delegate: catches clicks on our trigger (or any leftover native
    // #sizeChart before tidy removes it), fires before the theme's handler, blocks it. Immune
    // to the variant-change re-render.
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (!t.closest('#infant-sg-trigger, a#sizeChart, .sizeChart-label')) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      openPopup(type, product);
    }, true);

    // The theme RE-RENDERS the variant block on every variant change, recreating its native
    // #sizeChart inside .select-marime. Moving that node duplicated it. So instead we OWN the
    // trigger: delete EVERY native #sizeChart, keep exactly ONE of ours (#infant-sg-trigger)
    // placed as a full-width row below the variant/quantity row. Idempotent → no duplicates.
    function tidy() {
      var i;
      var natives = document.querySelectorAll('a#sizeChart');           // theme's trigger(s)
      for (i = 0; i < natives.length; i++) if (natives[i].parentNode) natives[i].parentNode.removeChild(natives[i]);
      var m = document.getElementById('sizeChartModel');                // empty native modal
      if (m && m.style.display !== 'none') m.style.display = 'none';
      var mine = document.querySelectorAll('#infant-sg-trigger');       // dedupe ours
      for (i = 1; i < mine.length; i++) if (mine[i].parentNode) mine[i].parentNode.removeChild(mine[i]);
      var t = document.getElementById('infant-sg-trigger');
      if (!t) {
        t = document.createElement('a');
        t.id = 'infant-sg-trigger';
        t.href = '#';
        t.className = 'sizeChart-label link';
        t.textContent = '📏 Ghidul de mărimi';
      }
      var grid = document.getElementById('infant-pdp-options-grid');
      var anchor = grid || document.querySelector('.product-quantity-wrapper') || document.querySelector('.option-selector');
      if (anchor) {
        if (t.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', t);
      } else if (!t.parentElement) {
        var form = document.querySelector('form[action*="/cart/add"]');
        if (form) form.insertBefore(t, form.firstChild);
      }
      // Pull our own delivery + seller/WhatsApp card (#infant-below-anchor, from
      // infant-pdp-enhancements.js — a single wrapper holding both) up to sit right under the
      // options/guide. Idempotent.
      var blk = document.getElementById('infant-below-anchor');
      if (blk && t && blk.previousElementSibling !== t) t.insertAdjacentElement('afterend', blk);
    }
    tidy();
    try {
      new MutationObserver(tidy).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  // ---- popup render ----
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }

  function openPopup(type, product) {
    closePopup();
    var node = (type === 'diaper') ? renderDiaper(product) : renderClothing(product);
    var overlay = el('<div id="infant-size-guide-overlay"><div id="infant-size-guide-popup" class="ig"></div></div>');
    overlay.querySelector('#infant-size-guide-popup').appendChild(node);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  }
  function closePopup() {
    var o = document.getElementById('infant-size-guide-overlay');
    if (o) o.remove();
    document.body.style.overflow = '';
  }

  // ---- CLOTHING ----
  function productSizesFromVariants(product) {
    // size option index: find the option named like a size
    var optIdx = -1;
    (product.options || []).forEach(function (o, i) {
      if (DATA.size_option_names.indexOf(M.norm(o.name || o)) !== -1) optIdx = i;
    });
    if (optIdx === -1) return []; // single-size product
    var seen = {}, out = [];
    (product.variants || []).forEach(function (v) {
      var label = v['option' + (optIdx + 1)];
      if (label == null) return;
      var key = M.norm(label);
      if (seen[key]) { if (v.available) seen[key].available = true; return; }
      seen[key] = { label: label, available: !!v.available };
      out.push(seen[key]);
    });
    return out;
  }

  function renderClothing(product) {
    var bands = DATA.clothing.bands, txt = DATA.clothing.texts;
    var sizes = productSizesFromVariants(product);
    var wrap = el('<div></div>');
    wrap.appendChild(el(header(txt, '✕')));
    wrap.appendChild(el(infoChip(txt.info)));
    // inputs: height (+ optional weight)
    wrap.appendChild(el(
      '<div class="inputs"><div class="fld"><label>ÎNĂLȚIMEA COPILULUI</label>' +
      stepper('h', 72, 'cm') + '</div><div class="fld"><label>GREUTATE <small>(opțional)</small></label>' +
      stepper('w', 9, 'kg') + '</div></div>'));
    var reco = el('<div class="reco"></div>'); wrap.appendChild(reco);
    var table = el('<div class="sg-table"></div>'); wrap.appendChild(table);
    wrap.appendChild(el(tip(txt.tip)));
    var cta = el('<button class="apply"></button>'); wrap.appendChild(cta);

    function refresh() {
      var h = parseFloat(wrap.querySelector('[data-k="h"] b').textContent);
      var w = parseFloat(wrap.querySelector('[data-k="w"] b').textContent);
      // Optional weight (spec §8): if a weight is entered and its band is LARGER than the
      // height band, drive the recommendation off the larger band (confort/creștere). The
      // highlighted table row follows the same chosen band. A gap weight yields -1 from
      // bandIndexForWeight, and -1 > hIdx is false, so we safely fall back to height.
      var hIdx = M.bandIndexForHeight(h, bands);
      var wIdx = isNaN(w) ? -1 : M.bandIndexForWeight(w, bands);
      var useWeight = wIdx > hIdx;
      var effIdx = useWeight ? wIdx : hIdx;
      var band = bands[effIdx];
      var effHeight = useWeight ? band.height[0] : h;
      table.innerHTML = clothingTableHtml(bands, band.label);
      var pick = sizes.length ? M.pickProductSize(effHeight, bands, sizes) : null;
      if (pick) {
        var chosen = sizes.filter(function (s) { return M.norm(s.label) === M.norm(pick.label); })[0];
        var oos = chosen && chosen.available === false;
        var oosSuggestion = '';
        if (oos) {
          var alt = M.nearestInStock(pick.label, bands, sizes);
          if (alt) oosSuggestion = '<p class="oos-alt">Cea mai apropiată disponibilă: <b>' + alt + '</b></p>';
        }
        reco.innerHTML = '<div class="reco-eyebrow">✓ MĂRIMEA RECOMANDATĂ</div>' +
          '<div class="t"><span>' + pick.label + '</span>' + (oos ? ' <em class="oos">(epuizat)</em>' : '') + '</div>' +
          '<p>' + recoNote(pick, band) + '</p>' + oosSuggestion;
        cta.style.display = '';
        cta.textContent = 'Alege mărimea ' + pick.label + ' →';
        cta.onclick = function () { if (!oos) setVariant(product, pick.label); closePopup(); };
      } else {
        // single-size product, OR sizes that don't resolve to an interval (e.g. letter
        // sizes S/M/L). pickProductSize returns null → fall through to informative branch,
        // show the height→band info, hide the CTA. No pick.label deref → no crash.
        reco.innerHTML = '<div class="reco-eyebrow">✓ MĂRIMEA TA (după înălțime)</div>' +
          '<div class="t"><span>' + band.label + '</span></div>' +
          '<p>Pentru ' + fmt(h) + ' cm. Verifică dacă produsul e disponibil în mărimea potrivită.</p>';
        cta.style.display = 'none';
      }
    }
    wireSteppers(wrap, refresh);
    wrap.querySelector('.x').onclick = closePopup;
    refresh();
    return wrap;
  }

  function recoNote(pick, band) {
    if (pick.status === 'exceeds') return 'Copilul depășește intervalul acestui produs. Vezi ghidul complet pentru o mărime mai mare.';
    if (pick.status === 'larger') return 'Cea mai apropiată mărime disponibilă pe acest produs.';
    return 'Pentru purtare mai lungă, poți alege o mărime mai mare.';
  }

  function fmt(n) { return String(n).replace('.', ','); }

  function clothingTableHtml(bands, hitLabel) {
    var rows = bands.map(function (b) {
      var hit = M.norm(b.label) === M.norm(hitLabel);
      return '<tr class="' + (hit ? 'hit' : '') + '"><td>' + b.label + (hit ? '<span class="chk">✓</span>' : '') +
        '</td><td class="r">' + fmt(b.height[0]) + '-' + fmt(b.height[1]) + ' cm</td><td class="r">' + fmt(b.weight[0]) + '-' + fmt(b.weight[1]) + ' kg</td></tr>';
    }).join('');
    return '<table><thead><tr><th>Mărime</th><th class="r">Înălțime</th><th class="r">Greutate</th></tr></thead><tbody>' + rows + '</tbody></table>';
  }

  function setVariant(product, label) {
    // find the size <select> / radio matching label and dispatch change
    var want = M.norm(label);
    var selects = document.querySelectorAll('form[action*="/cart/add"] select, form[action*="/cart/add"] input[type="radio"]');
    for (var i = 0; i < selects.length; i++) {
      var s = selects[i];
      if (s.tagName === 'SELECT') {
        for (var j = 0; j < s.options.length; j++) {
          if (M.norm(s.options[j].textContent) === want || M.norm(s.options[j].value) === want) {
            s.selectedIndex = j; s.dispatchEvent(new Event('change', { bubbles: true })); return;
          }
        }
      } else if (M.norm(s.value) === want) {
        s.checked = true; s.dispatchEvent(new Event('change', { bubbles: true })); return;
      }
    }
  }

  // ---- DIAPER ----
  function renderDiaper(product) {
    var cfg = DATA.diaper, txt = cfg.texts;
    // Spec §8.1 names the `brand-*` tag as the brand source; here we parse the title
    // (works for Pampers, where the title contains the brand). If a brand isn't in the
    // title, prefer reading it from a `brand-*` tag before falling back to _default.
    var parsed = M.parseDiaperTitle(product.title || '', cfg.brands);
    var brandCfg = (parsed.brand && cfg.brands[parsed.brand]) || null;
    var line = pickLine(brandCfg, product.title) || cfg.brands._default;
    var wrap = el('<div></div>');
    wrap.appendChild(el(header(txt, '✕')));
    wrap.appendChild(el(infoChip(txt.info)));
    wrap.appendChild(el('<div class="fld"><label>GREUTATEA COPILULUI</label>' + stepper('w', 9, 'kg') + '</div>'));
    var reco = el('<div class="reco"></div>'); wrap.appendChild(reco);
    var table = el('<div class="sg-table"></div>'); wrap.appendChild(table);
    wrap.appendChild(el('<div class="micro">Intervalele pot diferi între branduri.</div>'));
    wrap.appendChild(el(tip(txt.tip)));
    var cta = el('<button class="apply"></button>'); wrap.appendChild(cta);

    function refresh() {
      var w = parseFloat(wrap.querySelector('[data-k="w"] b').textContent);
      var rec = M.recommendDiaperNr(w, line);
      var hit = line.filter(function (r) { return r.nr === rec.nr; })[0];
      table.innerHTML = diaperTableHtml(line, rec.nr);
      reco.innerHTML = '<div class="reco-eyebrow">✓ MĂRIMEA RECOMANDATĂ</div>' +
        '<div class="t"><span>' + (hit ? hit.label : 'Nr. ' + rec.nr) + '</span></div>' +
        '<p>' + fmt(w) + ' kg → ' + (hit ? hit.label : 'Nr. ' + rec.nr) + '.</p>';
      // CTA: same Nr as current product? else sibling lookup
      if (parsed.nr && parsed.nr === rec.nr) {
        cta.style.display = 'none';
        reco.innerHTML += '<p class="ok">Mărimea acestui produs (Nr ' + parsed.nr + ') e potrivită ✓</p>';
      } else {
        cta.style.display = '';
        cta.textContent = 'Vezi scutecele Nr ' + rec.nr + ' →';
        cta.onclick = function () { gotoSibling(parsed, rec.nr); };
      }
    }
    wireSteppers(wrap, refresh);
    wrap.querySelector('.x').onclick = closePopup;
    refresh();
    return wrap;
  }

  function pickLine(brandCfg, title) {
    if (!brandCfg) return null;
    var s = M.norm(title);
    var keys = Object.keys(brandCfg).filter(function (k) { return k !== '_default'; });
    for (var i = 0; i < keys.length; i++) { if (s.indexOf(M.norm(keys[i])) !== -1) return brandCfg[keys[i]]; }
    return brandCfg._default || null;
  }

  function diaperTableHtml(line, hitNr) {
    var rows = line.map(function (r) {
      var hit = r.nr === hitNr;
      return '<tr class="' + (hit ? 'hit' : '') + '"><td>' + r.label + (hit ? '<span class="chk">✓</span>' : '') +
        '</td><td class="r">' + (r.display || (fmt(r.weight[0]) + '-' + fmt(r.weight[1]) + ' kg')) + '</td></tr>';
    }).join('');
    return '<table><thead><tr><th>Mărime</th><th class="r">Greutate</th></tr></thead><tbody>' + rows + '</tbody></table>';
  }

  function gotoSibling(parsed, nr) {
    // Phase 1 sibling discovery via suggest.json; safe fallback to collection/SEO page.
    // Query = the line from the raw title (strip the Nr) + the recommended Nr.
    var lineGuess = (parsed.raw || '').replace(/\s*nr\.?\s*\d+\+?.*/i, '').trim();
    var q = (lineGuess + ' Nr ' + nr).trim();
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (((d.resources || {}).results || {}).products) || [];
        var hit = ps.filter(function (p) {
          var t = M.norm(p.title);
          var nrHit = t.indexOf('nr ' + nr) !== -1 || t.indexOf('nr. ' + nr) !== -1 || t.indexOf('nr' + nr) !== -1;
          return nrHit && (!parsed.brand || t.indexOf(M.norm(parsed.brand)) !== -1);
        })[0] || null;
        if (hit && hit.url) { location.href = hit.url; }
        else { location.href = '/pages/ghid-marimi'; } // safe fallback — never a wrong deep-link
      })
      .catch(function () { location.href = '/pages/ghid-marimi'; });
  }

  // ---- shared UI bits ----
  function header(txt, x) {
    return '<div class="pop-h"><div><b>' + txt.title + '</b><em>' + txt.subtitle + '</em></div><span class="x">' + x + '</span></div>';
  }
  function infoChip(t) { return '<div class="info"><div class="i">i</div><p>' + t + '</p></div>'; }
  function tip(t) { return '<div class="tip"><div class="b">💡</div><p><strong>Sfat util:</strong> ' + t + '</p></div>'; }
  function stepper(k, val, unit) {
    return '<div class="step" data-k="' + k + '"><button data-d="-1">−</button><b>' + val + ' ' + unit + '</b><button data-d="1">+</button></div>';
  }
  function wireSteppers(wrap, refresh) {
    wrap.querySelectorAll('.step').forEach(function (st) {
      st.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var b = st.querySelector('b'); var parts = b.textContent.split(' ');
          var n = parseFloat(parts[0]) + parseInt(btn.getAttribute('data-d'), 10) * (st.getAttribute('data-k') === 'w' ? 0.5 : 1);
          if (n < 0) n = 0; b.textContent = n + ' ' + parts[1]; refresh();
        });
      });
    });
  }

  // ---- boot ----
  fetchProductJson(function (p) { init(p || getProduct()); });
})();
